import { Component, EventEmitter, HostBinding, Output } from '@angular/core';
import { animate, style, transition, trigger, state } from '@angular/animations';
import { environment } from 'environments/environment';

@Component({
  selector: 'cm-popup-corporate-website',
  templateUrl: './popup-corporate-website.component.html',
  styleUrls: ['./popup-corporate-website.component.scss'],
  animations: [
    trigger('init', [
      state('void', style({ right: '-110%', opacity: 0 })),
      transition('void <=> *', animate('0.75s cubic-bezier(0,0,0.5,1.15)')),
    ]),
  ],
})
export class PopupCorporateWebsiteComponent {
  link = environment.CERTEMY_WEBSITE_URL;
  @Output() closeClick = new EventEmitter();

  @HostBinding('@init') initTrigger = '';
}
